import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {mapSortings, mapFilters} from 'utils/grid-mappers';

import {
    pageNumber$,
    pageNumberChanged,
    fetchDataFx,
    filtersChanged,
    data$,
    filters$,
    Gate,
    pageIncremented,
    pageSize$,
    sortingsChanged,
    filtersReset,
    sortings$,
    sortingsReset,
    filtersSubmit,
    listStateChanged,
} from './index';

data$
    .on(fetchDataFx.done, (state, {result}) => state.concat(result))
    .reset(sortingsChanged, filtersChanged, Gate.close);
pageNumber$.reset(filtersSubmit, filtersReset, sortingsChanged, sortingsReset, Gate.close);
pageSize$.reset(Gate.close);

sample({
    clock: pageIncremented,
    source: pageNumber$.map((state) => state + 1),
    target: pageNumberChanged,
});

sample({
    clock: merge([Gate.open, listStateChanged]),
    source: combine({
        aggregateData: Gate.state,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        sortings: sortings$,
    }),
    fn: ({aggregateData, pageNumber, pageSize, filters, sortings}) => ({
        aggregationNumber: aggregateData.markingCode,
        gtin: aggregateData.gtin,
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
